import ClarityTracking from './ClarityTracking';
import Gtm from './Gtm';

export default function Tracking() {
  return (
    <>
      <Gtm />
      <ClarityTracking />
    </>
  );
}
